<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">
      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
          <div  class="login">
            <div class="logo">
              <h1>Unsubscribing...</h1>
            </div>

            <div class="login-content">
              <div class="swal2-show">
                <div v-if="unsubscribeStatus === 'success'" class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block;">
                  <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
                  <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                  <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                  <div class="swal2-success-ring"></div>
                  <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
                  <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
                </div>
                <div v-else-if="unsubscribeStatus === 'error'" class="swal2-icon swal2-error swal2-animate-error-icon" style="display: block; margin-top: 0; margin-bottom: 20px">
                  <span class="swal2-x-mark swal2-animate-x-mark">
                    <span class="swal2-x-mark-line-left"></span>
                    <span class="swal2-x-mark-line-right"></span>
                  </span>
                </div>
                <div v-else class="text-center">
                  <i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <div class="margin-20"></div>

              <p class="lead text-center" v-if="unsubscribeStatus === 'success'">Successfully Unsubscribed.</p>
              <p class="lead text-center" v-else-if="unsubscribeStatus === 'error'">Unauthorized.</p>
              <p class="lead text-center" v-else>...</p>
            </div>

            <div class="login-footer">
              <div class="row">
                <div class="col-xs-7">
                  <router-link :to="{ name: 'auth.login' }"><i class="fa fa-angle-left"></i> Back to Login</router-link>
                </div>
                <div class="col-xs-5 text-right">
                  <router-link :to="{ name: 'auth.register' }">Register</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        unsubscribeStatus: 'loading'
      }
    },

    created () {
      if (this.$route.query.signature && this.$route.query.carrier) {
        this.unsubscribeUser({ signature: this.$route.query.signature, carrier: this.$route.query.carrier }).then(response => {
          if (response.status === 200) {
            this.unsubscribeStatus = 'success'
          }
        }).catch(() => {
          this.unsubscribeStatus = 'error'
        })
      }
    },

    methods: {
      ...mapActions('user', ['unsubscribeUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// Unsubscribe.vue?26ff07a0